import map from 'lodash/fp/map';

import { toShortSemanticVersion } from '~/features/base/utils/versionNumberConverter';

export const parseControlDeviceInfo = controlDeviceInfo => {
    return {
        ...controlDeviceInfo,
        lastPackageVersionsReported: map(lastAppVersionReported => ({
            ...lastAppVersionReported,
            shortPackageVersion: toShortSemanticVersion(lastAppVersionReported.packageVersion),
        }), controlDeviceInfo.lastPackageVersionsReported),
    };
};
